import '../Honey/Honey.css';
import Sidebarprojects from '../Sidebar/Sidebarprojects';
import Honeytrace from './honey_trace.png';
import BeeBenefits from './BeeBenefits.png';
import '../Sidebar/Sidebardigital'
function Honey() {
    return (
      <div className="row">
                <div className="col-2 custom-display">
          <Sidebarprojects />
        </div>
        <div className="col-8 custom-width">
        <br/><br/>
            <h4><strong>Project Description</strong></h4><br/>
            <h5><strong>Working with 50 Beekeepers in the Karnal district</strong> of Haryana to make their Honey 100% traceable starting from Harvest 
              to the final consumer</h5>
            <br/>

        <br/><h4><strong>Honey Traceability solution</strong> - Beekeepers Benefits</h4><br/>
        {/* <br/><br/><img src={BeeBenefits} style={{width: '1000px', height: '350px'}} alt=" "/> */}
        <img src={BeeBenefits} style={{width: '100%', height: 'auto'}} alt=" "/>
          <br/><br/><br/><br/><h4><strong>Honey traceability</strong> has the follwing components</h4><br/>
          {/* <img src={Honeytrace} style={{width: '900px', height: '800px'}} alt=" "/> */}
          <img src={Honeytrace} style={{width: '100%', height: 'auto'}} alt=" "/>
          <br/><br/>
            </div>
            <br/><br/><br/><br/>
              <div className="col-2 custom-display">
              
            </div>
            </div>
    );
    }
  export default Honey;